import { company } from '@/data/company';
import { SocialIcon } from '@/components/common/SocialIcon';

const links = [
  { ...company.socials.facebook, network: 'facebook' as const },
  { ...company.socials.instagram, network: 'instagram' as const },
  { ...company.socials.linkedin, network: 'linkedin' as const },
  { ...company.socials.x, network: 'x' as const }
];

export function SocialLinks() {
  return (
    <div>
      <h2 className="text-sm font-semibold text-text-primary">Pratite nas</h2>
      <div className="mt-3 flex flex-wrap gap-2">
        {links.map(link => (
          <a
            key={link.label}
            className="grid size-11 place-items-center rounded-full border border-border bg-surface text-sm font-semibold text-text-secondary transition-[color,border-color,transform] hover:-translate-y-0.5 hover:border-border-strong hover:text-text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/35"
            href={link.url}
            target="_blank"
            rel="noreferrer"
            aria-label={link.label}
          >
            <SocialIcon network={link.network} />
          </a>
        ))}
      </div>
    </div>
  );
}
